module.exports = __webpack_public_path__ + "img/palomexter.75d4ae7f.jpg";